Slider = require '../../requires/pc/ui/slider'
require 'html5shiv'

###
multiple new class
###
newClass = (className, el, opts) ->
  $ el
    .each ({}, _el) ->
      if opts
        new className _el, opts
      else
        new className _el

$ document
  .one 'ready', ->

    _.forEach [
      [ Slider, '.js-slider' ]
      [ Slider, '.js-slider-no-dot',
        slickOpts:
          dots: false
      ]
    ], (arr) ->
      newClass.apply @, arr



/** WEBPACK FOOTER **
 ** ./webpack/src/js/index.coffee
 **/